// Web version of useStripeLinking
// Deep link handling is not needed for web as Stripe handles redirects differently
export const useStripeLinking = () => {
  // No-op for web - Stripe handles web redirects through browser navigation
  // instead of deep links like on mobile
};
